<template>
    <div class="edit-zona">
        <div v-if="!edit" v-html='formatRisultatoByUmId(filteredValore, um_id, false)' />
        <span class="edit" v-else>
            <input-select v-if="isTime(um_id)" :format="'ms'" :modelValue="hmsValue" @update:modelValue="updateHms" :placeholder="formatRisultatoByUmId(filteredValore, um_id, false)"/>
            <input v-else size=3 :value="editValore" @change="updateValue" type="text" :placeholder="formatRisultatoByUmId(filteredValore, um_id, false)"/>
        </span>
    </div>
</template>

<script>

import _funzioni from '@src/js/msp/funzioni.js';
import _constants from '@src/js/msp/constants.js';
import InputSelect from "./InputSelect.vue";
const component = {
    components: {
        InputSelect,
    },
    props: ['zona', 'mode', 'key_valore', 'um_id' ],
    data: function () {
        const data = {
            value: 0,

        };
        return data;
    },
    created: function () {


    },
    computed: {
        
        hmsValue: function () {
            // il risultato è salvato come min/km, ma a me servono i sec/mt
            const converted = this.um2mt(this.filteredValore);
            return _funzioni.sec2hms(converted);
        },

        edit: function () {
            return this.mode === 'edit';
        },

        filteredValore: function () {

            let fv;
            if (!this.zona) {
                return 0;
            }
            if (this.key_valore!="media") {
                fv = this.zona[this.key_valore];
            } else {
                let media = (this.zona.da + this.zona.a)/2;
                fv = media;
            }
            return fv;
        },

        editValore: function () {
            const v = this.filteredValore;
            if (v == null || v === '') return v;
            return Math.round(v);
        },
    },

    mounted: function () {
    },

    watch: {
    },
    methods: {
        um2um: _funzioni.um2um,
        isTime: _funzioni.isTime,

        um2mt: function (value) {
            return this.um2um(value, this.um_id, _constants.UMS.mt);
        },

        mt2um: function (value) {
            return this.um2um(value, _constants.UMS.mt, this.um_id);
        },

        updateValue: function (ev) {
            if (!ev.target.value) return;

            this.value = Number(ev.target.value);
            this.update();
        },

        updateHms: function (hms) {
            this.value = this.mt2um(_funzioni.hms2sec(hms));
            this.update();
        },

        update: function () {
            if (!this.value) return;

            let payload = {
                zona: this.zona,
                value: this.value,
                key_valore: this.key_valore,
            };
            this.$emit('update', payload);
        },
        formatRisultatoByUmId(val, um_id, hasUm = true) {
            return _funzioni.formatRisultatoByUmId(val, um_id, null, hasUm);
        },


    }
}
    export default component;
    </script>

<style lang="scss">
.edit-zona {
    input {
        box-sizing: border-box;
        border: 1px #aaa dotted;
        width: 5em;
        max-width: 100%;
    }
}
</style>
